import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-porcentaje-final-cesion',
  templateUrl: './porcentaje-final-cesion.component.html',
  styleUrls: ['./porcentaje-final-cesion.component.css']
})
export class PorcentajeFinalCesionComponent {

  public rows = [];
  public actualRow;
  public formulario;
  public valor;


  constructor(private _changeDetectionRef: ChangeDetectorRef,) {

    this.formulario = new FormGroup({
      porcentajeFinal: new FormControl(''),

    })

    if (!JSON.parse(localStorage.getItem("porcentaje_finalCesion"))) {
      localStorage.setItem("porcentaje_finalCesion", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("porcentaje_finalCesion"));
      this.formulario.controls['porcentajeFinal'].setValue(this.rows[0] ? this.rows[0].porcentajeFinal : '')
    }

  }

  add_porcentajes() {


    localStorage.setItem("porcentaje_finalCesion", JSON.stringify([]));
    this.actualRow = localStorage.getItem("porcentaje_finalCesion");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      porcentajeFinal: this.formulario.value.porcentajeFinal,

    })
    localStorage.setItem("porcentaje_finalCesion", JSON.stringify(this.rows));

    console.log(this.rows);
    
  }

  delete_normas(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("porcentaje_finalCesion", JSON.stringify(this.rows));
      }
    }
  }
}
